import { remove } from '@core/api/baseApi';

const deleteSolicitation = async (
  studyInstanceUid: string,
  attachmentKey: number | null | undefined,
): Promise<{ success: boolean }> =>
  await remove(`/studies/${studyInstanceUid}/solicitation/${attachmentKey}`);

export default deleteSolicitation;
